var render, staticRenderFns
import script from "./TableCellVialsTotalNewPatients.vue?vue&type=script&lang=js&"
export * from "./TableCellVialsTotalNewPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59eb923e')) {
      api.createRecord('59eb923e', component.options)
    } else {
      api.reload('59eb923e', component.options)
    }
    
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-cells/TableCellVialsTotalNewPatients.vue"
export default component.exports